import {useMemo} from "react";
import {css} from "@emotion/react";

import {calculateRemSize, mt} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {CompletedStepPoint, ForYouModalStepPoint} from "./ForYouModalStepPoint";

export const ForYouModalProgress = () => {
    const modalStep = useAppSelector((state) => state.forYouModal.step);

    const stepsIndicators = [
        {label: "Lokalizacja", step: ForYouModalStep.REGION},
        {label: "Kryteria", step: ForYouModalStep.CRITERIA},
        {label: "Twoje dane", step: ForYouModalStep.USER}
    ];
    const stepProgress = useMemo(() => getStepsProgress(modalStep), [modalStep]);

    return (
        <div css={progressStyle}>
            {stepsIndicators.map((element, index) => (
                <div key={element.label} css={stepStyle}>
                    {stepProgress[element.step] ? <CompletedStepPoint /> : <ForYouModalStepPoint isActive={element.step === modalStep} position={index + 1} />}
                    <Text variant="info_txt_1">{element.label}</Text>
                </div>
            ))}
        </div>
    );
};

interface IStepsProgress {
    [key: number]: boolean;
}

const getStepsProgress = (step: ForYouModalStep): IStepsProgress => {
    switch (step) {
        case ForYouModalStep.REGION:
            return {[ForYouModalStep.REGION]: false, [ForYouModalStep.CRITERIA]: false, [ForYouModalStep.USER]: false};
        case ForYouModalStep.CRITERIA:
            return {[ForYouModalStep.REGION]: true, [ForYouModalStep.CRITERIA]: false, [ForYouModalStep.USER]: false};
        case ForYouModalStep.USER:
            return {[ForYouModalStep.REGION]: true, [ForYouModalStep.CRITERIA]: true, [ForYouModalStep.USER]: false};
        default:
            return {[ForYouModalStep.REGION]: true, [ForYouModalStep.CRITERIA]: true, [ForYouModalStep.USER]: true};
    }
};

const progressStyle = css`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    position: relative;
    ${mt(1.5)};

    &:after {
        content: "";
        position: absolute;
        top: calc(33px / 2);
        left: 22px;
        right: 22px;
        border-top: 1px solid ${getThemeVariable("colors.gray.500")};
    }

    .active-step {
        background-color: ${getThemeVariable("colors.gray.400")};
        border: 1px solid ${getThemeVariable("colors.gray.600")};
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mt(0)};
        &:after {
            top: calc(44px / 2);
        }
    }
`;

const stepStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${calculateRemSize(1)};
    z-index: 1;
`;
import {useMemo} from "react";
import {css} from "@emotion/react";

import {calculateRemSize, mt} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {CompletedStepPoint, ForYouModalStepPoint} from "./ForYouModalStepPoint";

export const ForYouModalProgress = () => {
    const modalStep = useAppSelector((state) => state.forYouModal.step);

    const stepsIndicators = [
        {label: "Lokalizacja", step: ForYouModalStep.REGION},
        {label: "Kryteria", step: ForYouModalStep.CRITERIA},
        {label: "Twoje dane", step: ForYouModalStep.USER}
    ];
    const stepProgress = useMemo(() => getStepsProgress(modalStep), [modalStep]);

    return (
        <div css={progressStyle}>
            {stepsIndicators.map((element, index) => (
                <div key={element.label} css={stepStyle}>
                    {stepProgress[element.step] ? <CompletedStepPoint /> : <ForYouModalStepPoint isActive={element.step === modalStep} position={index + 1} />}
                    <Text variant="info_txt_1">{element.label}</Text>
                </div>
            ))}
        </div>
    );
};

interface IStepsProgress {
    [key: number]: boolean;
}

const getStepsProgress = (step: ForYouModalStep): IStepsProgress => {
    switch (step) {
        case ForYouModalStep.REGION:
            return {[ForYouModalStep.REGION]: false, [ForYouModalStep.CRITERIA]: false, [ForYouModalStep.USER]: false};
        case ForYouModalStep.CRITERIA:
            return {[ForYouModalStep.REGION]: true, [ForYouModalStep.CRITERIA]: false, [ForYouModalStep.USER]: false};
        case ForYouModalStep.USER:
            return {[ForYouModalStep.REGION]: true, [ForYouModalStep.CRITERIA]: true, [ForYouModalStep.USER]: false};
        default:
            return {[ForYouModalStep.REGION]: true, [ForYouModalStep.CRITERIA]: true, [ForYouModalStep.USER]: true};
    }
};

const progressStyle = css`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    position: relative;
    ${mt(1.5)};

    &:after {
        content: "";
        position: absolute;
        top: calc(33px / 2);
        left: 22px;
        right: 22px;
        border-top: 1px solid ${getThemeVariable("colors.gray.500")};
    }

    .active-step {
        background-color: ${getThemeVariable("colors.gray.400")};
        border: 1px solid ${getThemeVariable("colors.gray.600")};
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${mt(0)};
        &:after {
            top: calc(44px / 2);
        }
    }
`;

const stepStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${calculateRemSize(1)};
    z-index: 1;
`;
